import React, { forwardRef } from 'react';
import './Input.css';

const Input = forwardRef(({ 
  as = "input",
  type = "text",
  name,
  value,
  onChange,
  placeholder,
  required = false,
  disabled = false,
  className = "",
  rows,
  hidden,
  ...props
}, ref) => {
  const Component = as;
  const textareaClass = as === 'textarea' ? 'input--textarea' : '';
  const hiddenStyle = hidden ? { display: 'none' } : {};
  
  return (
    <Component
      ref={ref}
      type={as === "input" ? type : undefined}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      rows={rows}
      className={`input ${textareaClass} ${className}`}
      style={hiddenStyle}
      {...props}
    />
  );
});

Input.displayName = 'Input';

export default Input;
